import { useApi } from 'services';

export const useAccess = (syncRequest) => useApi(`/access`, 'POST', {}, {}, syncRequest);
